import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import select from '../FormComponents/select';
import AsyncSelect from 'react-select/async';
import './styles.scss';
import useTheme from '../../theme/useTheme';

const CompanySelect = ({
  field,
  name,
  setFieldValue,
  defaultValue,
  setFieldTouched,
  noOptionMessage,
  loadOptions,
  ...props
}) => {
  const { theme } = useTheme();
  const { t } = useTranslation();

  const [inputLength, setInputLength] = useState(0);

  const onInputEntered = inputText => {
    setInputLength(inputText.length);
  };

  const displayMessage = () => {
    return inputLength === 1 || inputLength === 2 ? t('company.minimumInputCharacters') : noOptionMessage;
  };

  return (
    <AsyncSelect
      {...field}
      {...props}
      className={`styled-company-select ${props.className}`}
      defaultValue={defaultValue}
      value={field && field.value && field.value.value}
      onChange={
        props.onChange
          ? props.onChange
          : option => {
              setFieldTouched(name);
              setFieldValue(name, option);
            }
      }
      isClearable
      filterOptions={options => options}
      loadOptions={inputLength >= 3 ? loadOptions : undefined}
      noOptionsMessage={() => displayMessage()}
      onInputChange={e => onInputEntered(e)}
      styles={select(theme)}
      autosize={false}
    />
  );
};

export default CompanySelect;
